export default __webpack_public_path__ + "static/media/bag.14b33ff0.svg";